<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container style="max-width: 600px;">
    <v-timeline dense clipped>
      <v-slide-x-transition group>
        <v-timeline-item
          v-for="event in history"
          :key="event._id"
          class="mb-3"
          :color="colorDot(event.alertType)"
          small
        >
          <v-layout justify-space-between>
            <v-flex xs7 v-text="eventDescription(event)"></v-flex>
            <v-flex
              xs5
              text-xs-right
              v-text="shortDate(event.eventTime)"
            ></v-flex>
          </v-layout>
          <v-btn
            v-if="event.receipt"
            outline
            color="indigo"
            round
            @click="viewReceipt(event.receipt)"
            >View Receipt</v-btn
          >
        </v-timeline-item>
      </v-slide-x-transition>
    </v-timeline>
  </v-container>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(utc);
dayjs.extend(LocalizedFormat);

export default {
  name: 'Timeline',
  props: ['history'],
  data: () => ({}),
  methods: {
    colorDot(alertType) {
      switch (alertType) {
        case 'subscription_created':
          return 'success';
        case 'subscription_payment_succeeded':
          return 'info';
        case 'subscription_cancelled':
          return 'error';
        case 'subscription_updated':
          return 'accent';
        case 'subscription_payment_refunded':
          return 'purple';
        case 'subscription_payment_failed':
          return 'indigo';
        default:
          return 'pink';
      }
    },
    shortDate(dateString) {
      return dayjs.utc(dateString).format('lll');
    },
    planName(planId) {
      switch (planId) {
        case '562350':
          return 'Groupmail Start (Monthly)';
        case '562351':
          return 'Groupmail Grow (Monthly)';
        case '562352':
          return 'Groupmail Pro (Monthly)';
        case '562471':
          return 'Groupmail Start (Annual)';
        case '562472':
          return 'Groupmail Grow (Annual)';
        case '562473':
          return 'Groupmail Pro (Annual)';
        default:
          return 'Unknown plan';
      }
    },
    eventDescription(eventData) {
      switch (eventData.alertType) {
        case 'subscription_created':
          return `Subscription to ${this.planName(
            eventData.plan
          )} successfully created.`;
        case 'subscription_payment_succeeded':
          return `Payment for ${this.planName(
            eventData.plan
          )} successfully processed.`;
        case 'subscription_cancelled':
          if (eventData.plan) {
            return `Subscription to ${this.planName(
              eventData.plan
            )} cancelled.`;
          }
          return 'Subscription cancelled.';
        case 'subscription_updated':
          return `Subscription (${this.planName(
            eventData.plan
          )}) successfully updated.`;
        case 'subscription_payment_refunded':
          return 'Payment refunded.';
        case 'subscription_payment_failed':
          return 'Payment failed.';
        default:
          return '(Unknown event)';
      }
    },
    viewReceipt(receipt) {
      window.open(receipt, '_blank');
    }
  }
};
</script>
